/**
 * 在线报名
 */
import axios from '../utils/http';

// 获取顶部banner
const getTopAds = params => {
    return axios.request({
        data: {
        ...params
        },
        method: 'post',
        url: '/v1/ad/getTopAds'
    })
}

// 获取报名院校列表
const getRegistActivityList = params => {
    return axios.request({
        data: {
        ...params
        },
        method: 'get',
        url: '/registActivity/list'
    })
}


  
export default {
    getTopAds,
    getRegistActivityList
}